<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <h3 class="titles">影院自助售取票机</h3>
    <div class="content">
      <div class="item" @click="take">
        <h3>取票</h3>
        <p>Take</p>
      </div>
      <div class="item" @click="buy">
        <h3>购票</h3>
        <p>Buy</p>
      </div>
    </div>
    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
    <div class="back" @click.self="goBack">首页</div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      timer: ""
    };
  },
  mounted() {
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    },
    goBack() {
      this.$router.replace("/");
    },
    // 前往取票系统
    take() {
      this.$router.push("/take");
    },
    // 前往影院购票系统
    buy() {
      this.$router.push("/buy");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: url(.././assets/buy_movie.png) no-repeat top center;
  overflow: hidden;
  .top {
    padding: 30px 32px;
    color: #fff;
    height: 564px;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 72px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: center;
    margin: 131px;
  }
}
.content {
  padding: 0 60px;
  overflow: hidden;
  .item {
    width: 450px;
    height: 520px;
    float: left;
    border-radius: 6px;
    background: url(.././assets/buy.png) no-repeat;
    background-size: cover;
    &:first-child {
      margin-right: 60px;
      background: url(.././assets/take.png) no-repeat;
      background-size: cover;
      p {
        padding-right: 80px;
      }
    }
    h3 {
      text-align: right;
      margin-top: 320px;
      color: #fff;
      font-size: 70px;
      letter-spacing: 4px;
      padding-right: 40px;
    }
    p {
      margin-top: 10px;
      text-align: right;
      color: #fff;
      font-size: 50px;
      padding-right: 90px;
    }
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 43%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: fixed;
  bottom: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Movie.vue